import { useContext } from 'react';
import { ConjointAnalysisResponsesContext, MaxDiffResponsesContext } from '@containers/SurveyResponses/Context';

export const useConjointAnalysisSurveyResponses = () => useContext(ConjointAnalysisResponsesContext);
export const useMaxDiffSurveyResponses = () => useContext(MaxDiffResponsesContext);